export const roadmap = [
  {
    phase: "Phase 1 – Core Java Foundations (Master Level)",
    topics: [
      {
        title: "Java Core & Internals",
        points: [
          "Variables, Data Types, Operators",
          "Flow Control",
          "Methods",
          "Access Modifiers",
          "OOPS (Encapsulation, Abstraction, Inheritance, Polymorphism)",
          "Classes vs Objects",
          "Constructors",
          "static, final, this, super",
          "Inner Classes",
          "Packages",
          "Exception Handling (try, catch, finally)",
          "throw vs throws",
          "Checked vs Unchecked Exceptions",
          "Custom Exceptions",
          "Heap vs Stack",
          "JVM, JRE, JDK",
          "Garbage Collection",
          "Class Loader",
          "String Pool",
          "== vs equals()",
          "Memory Leaks & Profiling",
        ],
      },
      {
        title: "Collections & Generics (Deep Understanding)",
        points: [
          "List (ArrayList, LinkedList)",
          "Set (HashSet, LinkedHashSet, TreeSet)",
          "Map (HashMap, LinkedHashMap, TreeMap)",
          "Queue, PriorityQueue",
          "Comparator vs Comparable",
          "Iterator vs ListIterator",
          "HashMap Internals",
          "Collision Handling",
          "Load Factor",
          "Fail Fast vs Fail Safe",
          "ConcurrentHashMap Internals",
          "Generics",
          "Wildcards",
          "Type Erasure",
        ],
      },
      {
        title: "Multithreading & Concurrency",
        points: [
          "Thread & Runnable",
          "Thread Lifecycle",
          "Synchronization",
          "Locks & Deadlocks",
          "Race Condition",
          "Volatile",
          "Atomic Classes",
          "ExecutorService",
          "Thread Pools",
          "CompletableFuture",
          "ForkJoinPool",
          "Virtual Threads",
        ],
      },
      {
        title: "Modern Java",
        points: [
          "Lambda Expressions",
          "Stream API",
          "Functional Interfaces",
          "Predicate, Consumer, Supplier, Function",
          "Optional",
          "Method References",
          "Records",
          "Sealed Classes",
        ],
      },
    ],
  },

 {
  "phase": "Phase 2 – DSA (Interview Core)",
  "topics": [
    {
      "title": "DSA Foundations + Arrays",
      "points": [
        "DSA Foundations",
        "Arrays",
        "Time Complexity",
        "Constraints Analysis",
        "Bit Manipulation (Basics + Patterns)",
        "Mathematics (GCD, LCM, Modular Arithmetic basics)",
        "Arrays & Basic Hashing",
        "Prefix Sum / Difference Array",
        "Frequency Maps"
      ]
    },
    {
      "title": "Two Pointers + Sliding Window + Strings",
      "points": [
        "Two Pointers",
        "Meet In The Middle",
        "Sliding Window",
        "Strings Basics"
      ]
    },
    {
      "title": "Binary Search + Stack + Queue",
      "points": [
        "Classic Binary Search",
        "Binary Search Optimizations",
        "Monotonic Functions",
        "Next Greater Element Problems",
        "Monotonic Stack (Standard + CP Problems)",
        "Queue / Deque Problems"
      ]
    },
    {
      "title": "Recursion + Backtracking + Sorting",
      "points": [
        "Base Cases & Recursion Tree",
        "Generate Patterns",
        "N-Queens",
        "Subsets & Permutations",
        "Grid-based Problems",
        "Merge Sort",
        "Quick Sort"
      ]
    },
    {
      "title": "Trees (Binary Tree + BST)",
      "points": [
        "Traversals (Inorder, Preorder, Postorder, Level Order)",
        "Array Representation of Trees",
        "Height & Diameter",
        "BST Insert, Delete, Search",
        "Valid BST",
        "Lowest Common Ancestor (LCA)"
      ]
    },
    {
      "title": "Priority Queue + Greedy",
      "points": [
        "Min / Max Heap",
        "Top K Problems",
        "Running Median",
        "Interval Scheduling",
        "Fractional Knapsack",
        "Job Sequencing",
        "Greedy vs DP Intuition"
      ]
    },
    {
      "title": "Dynamic Programming",
      "points": [
        "Recursion",
        "Memoization (Top Down)",
        "Tabulation (Bottom Up)",
        "Space Optimization",
        "1D DP",
        "2D DP",
        "Grid DP",
        "String DP",
        "Subsequence DP",
        "LIS DP",
        "Tree DP"
      ]
    },
    {
      "title": "Graphs",
      "points": [
        "BFS",
        "DFS",
        "Connected Components",
        "Cycle Detection",
        "Topological Sort",
        "Dijkstra (Shortest Path)",
        "Disjoint Set (Union-Find)"
      ]
    },
    {
      "title": "Binary Search + Math Foundations (Advanced)",
      "points": [
        "Constraint Reading / Time Complexity Reverse Engineering",
        "Binary Search on Answer",
        "Bit Manipulation Basics",
        "Modular Arithmetic",
        "Fast Exponentiation",
        "Related Codeforces Problems"
      ]
    },
    {
      "title": "Number Theory + Combinatorics + Array Ideas",
      "points": [
        "GCD, LCM, Extended Euclid (Intuition)",
        "Prime Sieve",
        "Modular Exponentiation",
        "nCr with Mod",
        "Divisors & Factorization",
        "Combinatorics Patterns",
        "Prefix Sum",
        "Line Sweep Algorithm",
        "Related Codeforces Problems"
      ]
    },
    {
      "title": "Recursion & Backtracking (Advanced)",
      "points": [
        "Backtracking Pruning",
        "Subsets & Permutations",
        "Complete Search"
      ]
    },
    {
      "title": "Stacks, Queues & Monotonic Structures",
      "points": [
        "Monotonic Stack",
        "Sliding Window + Deque",
        "Monotonic Stack Problems (Codeforces)"
      ]
    }
  ]
},

  {
    phase: "Phase 3 – Web & Backend Foundations",
    topics: [
      {
        title: "Internet & Web Fundamentals",
        points: [
          "Client vs Server",
          "HTTP & HTTPS",
          "TCP vs UDP",
          "IP & Ports",
          "DNS",
          "Request-Response Lifecycle",
          "Cookies vs Sessions",
          "Session Management",
          "REST Principles",
          "Idempotency",
          "HTTP Methods (GET, POST, PUT, DELETE, PATCH)",
          "HTTP Status Codes (200, 201, 204, 400, 401, 403, 404, 500, 502, 503)",
          "Headers & JSON",
          "Stateless APIs",
        ],
      },
      {
        title: "Git & Version Control",
        points: [
          "Branching Strategy",
          "Pull Requests",
          "Code Reviews",
          "Rebase vs Merge",
          "Tags & Releases",
        ],
      },
    ],
  },

  {
    phase: "Phase 4 – Spring & Spring Boot (Enterprise Core)",
    topics: [
      {
        title: "Spring Core",
        points: [
          "IOC",
          "Dependency Injection",
          "Beans & Bean Lifecycle",
          "Scopes",
          "Autowiring",
          "AOP Basics",
          "Controller-Service-Repository Layers",
        ],
      },
      {
        title: "Spring Boot",
        points: [
          "Starters",
          "Auto-Configuration",
          "Startup Flow",
          "Profiles",
          "Configuration Properties",
          "Logging (SLF4J, Logback)",
          "Spring Boot Actuator",
          "Health Checks & Metrics",
        ],
      },
      {
        title: "REST API Development",
        points: [
          "@RestController vs @Controller",
          "Mapping Annotations",
          "PathVariable, RequestParam, RequestBody",
          "ResponseEntity",
          "Validation (@Valid, Hibernate Validator)",
          "Custom Validators",
          "Global Exception Handling (@ControllerAdvice)",
          "Swagger / OpenAPI",
          "Postman Testing",
        ],
      },
    ],
  },

  {
    phase: "Phase 5 – Database & Persistence",
    topics: [
      {
        title: "SQL (PostgreSQL + MySQL)",
        points: [
          "Joins",
          "Aggregations",
          "Subqueries",
          "Indexing",
          "Transactions",
          "ACID",
          "Isolation Levels",
          "Normalization",
          "Query Optimization",
          "Explain Plans",
          "Stored Procedures",
        ],
      },
      {
        title: "JPA & Hibernate",
        points: [
          "Entity Lifecycle",
          "OneToOne, OneToMany, ManyToMany",
          "Cascade",
          "Lazy vs Eager",
          "N+1 Problem",
          "Pagination",
          "JPQL",
          "Criteria API",
          "Native Queries",
          "Caching",
        ],
      },
      {
        title: "Database Engineering",
        points: [
          "Read Replicas",
          "Partitioning",
          "Sharding",
          "Replication",
          "Backups",
          "Flyway",
          "Liquibase",
          "CAP Theorem",
        ],
      },
    ],
  },

  {
    phase: "Phase 6 – Advanced Backend & Architecture",
    topics: [
      {
        title: "Spring Security",
        points: [
          "Authentication vs Authorization",
          "Role-Based Access",
          "JWT",
          "Filters",
          "CSRF",
          "Method-Level Security",
          "OAuth2",
          "Refresh Tokens",
        ],
      },
      {
        title: "Caching & Redis",
        points: [
          "Caching Strategies",
          "TTL",
          "Eviction Policies",
          "@Cacheable, @CacheEvict",
          "Pub/Sub",
          "Distributed Locks",
          "Rate Limiting",
        ],
      },
      {
        title: "Microservices Architecture",
        points: [
          "Monolith vs Microservices",
          "Service Discovery (Eureka)",
          "API Gateway",
          "Config Server",
          "Load Balancer",
          "Resilience4j / Circuit Breaker",
          "Feign Client",
          "WebClient",
          "Distributed Tracing",
        ],
      },
      {
        title: "Messaging & Event-Driven Systems",
        points: [
          "Kafka",
          "RabbitMQ",
          "Topics & Partitions",
          "Consumer Groups",
          "Exactly Once Processing",
          "Async Processing",
        ],
      },
    ],
  },

  {
    phase: "Phase 7 – DevOps & Cloud",
    topics: [
      {
        title: "Docker & Kubernetes",
        points: [
          "Dockerfiles",
          "Images & Containers",
          "Volumes & Networks",
          "Docker Compose",
          "Kubernetes (Pods, Services, Ingress, Autoscaling)",
          "Helm",
        ],
      },
      {
        title: "Cloud (AWS / GCP)",
        points: ["EC2", "RDS", "S3", "IAM", "Load Balancer", "CI/CD Pipelines"],
      },
    ],
  },

  {
    phase: "Phase 8 – Observability, Testing & Production Engineering",
    topics: [
      {
        title: "Logging & Monitoring",
        points: [
          "Logback",
          "ELK / EFK",
          "Prometheus",
          "Grafana",
          "Zipkin / Jaeger",
          "OpenTelemetry",
          "Alerts",
        ],
      },
      {
        title: "Testing",
        points: [
          "JUnit",
          "Mockito",
          "Unit Testing",
          "Integration Testing",
          "API Testing",
          "Load Testing",
        ],
      },
    ],
  },

  {
    phase: "Phase 9 – Real Projects (Proof of Excellence)",
    topics: [
      {
        title: "Mandatory Projects",
        points: [
          "User Management System",
          "E-commerce Backend",
          "Payment System",
          "Microservices Architecture Project",
          "Kafka + Redis Real-time System",
          "Chat System (WebSocket + Kafka)",
          "Deployed Portfolio Projects",
        ],
      },
    ],
  },

  {
    phase: "Phase 10 – System Design & Interview Preparation",
    topics: [
      {
        title: "System Design",
        points: [
          "Load Balancing",
          "Scalability",
          "Horizontal vs Vertical Scaling",
          "Database Scaling",
          "Sharding & Replication",
          "Consistency Models",
          "Caching Layers",
          "Rate Limiting",
          "Designing Amazon / Instagram / Swiggy / Payment Systems",
        ],
      },
      {
        title: "Interview Preparation",
        points: [
          "DSA Revision",
          "Java Internals",
          "Spring Boot",
          "SQL",
          "Redis",
          "Kafka",
          "Microservices",
          "System Design Mock Interviews",
        ],
      },
    ],
  },
  {
    phase: "Phase 11 – Software Engineering Fundamentals (Industry Readiness)",
    topics: [
      {
        title: "Clean Code & Engineering Practices",
        points: [
          "Clean Code Principles",
          "SOLID Principles",
          "DRY Principle",
          "KISS Principle",
          "YAGNI Principle",
          "Code Smells",
          "Refactoring Techniques",
          "Code Reviews",
          "Design by Contract",
          "Defensive Programming",
          "Error Handling Patterns",
          "Null Safety",
          "Immutability",
          "Builder Pattern Usage",
          "Configuration Management",
        ],
      },
      {
        title: "Design Patterns (Enterprise Level)",
        points: [
          "Singleton",
          "Factory",
          "Abstract Factory",
          "Builder",
          "Prototype",
          "Adapter",
          "Decorator",
          "Facade",
          "Proxy",
          "Composite",
          "Observer",
          "Strategy",
          "Command",
          "Template Method",
          "Chain of Responsibility",
          "State Pattern",
          "Mediator Pattern",
        ],
      },
    ],
  },

  {
    phase: "Phase 12 – Performance Engineering",
    topics: [
      {
        title: "Performance Optimization",
        points: [
          "Big-O Complexity Analysis",
          "CPU vs Memory Tradeoffs",
          "Profiling Applications",
          "Thread Dump Analysis",
          "Heap Dump Analysis",
          "Garbage Collection Tuning",
          "Latency vs Throughput",
          "Connection Pooling",
          "Database Query Optimization",
          "N+1 Query Optimization",
          "Batch Processing",
          "Async Processing",
          "Backpressure Handling",
        ],
      },
    ],
  },

  {
    phase: "Phase 13 – Advanced Distributed Systems",
    topics: [
      {
        title: "Distributed Systems Concepts",
        points: [
          "Distributed Architecture",
          "Consensus Algorithms",
          "Leader Election",
          "Distributed Locks",
          "Eventual Consistency",
          "Strong Consistency",
          "CAP Theorem Deep Dive",
          "Vector Clocks",
          "Idempotent APIs",
          "Saga Pattern",
          "Two Phase Commit",
          "Distributed Transactions",
          "Event Sourcing",
          "CQRS Pattern",
        ],
      },
    ],
  },

  {
    phase: "Phase 14 – API Engineering & Production APIs",
    topics: [
      {
        title: "Enterprise API Design",
        points: [
          "REST API Versioning",
          "Backward Compatibility",
          "Pagination Strategies",
          "Filtering & Sorting APIs",
          "Rate Limiting APIs",
          "API Gateway Design",
          "GraphQL Basics",
          "gRPC",
          "OpenAPI Specifications",
          "Contract Testing",
          "API Security Best Practices",
          "API Throttling",
          "API Observability",
        ],
      },
    ],
  },

  {
    phase: "Phase 15 – Data Engineering for Backend Engineers",
    topics: [
      {
        title: "Data Storage Systems",
        points: [
          "Relational Databases",
          "NoSQL Databases",
          "Document Databases",
          "Column Databases",
          "Time Series Databases",
          "Search Engines (Elasticsearch)",
          "Full Text Search",
          "Data Pipelines",
          "Batch vs Stream Processing",
          "ETL Pipelines",
          "Data Lake Basics",
        ],
      },
    ],
  },

  {
    phase: "Phase 16 – Security Engineering",
    topics: [
      {
        title: "Application Security",
        points: [
          "OWASP Top 10",
          "SQL Injection",
          "Cross Site Scripting (XSS)",
          "Cross Site Request Forgery (CSRF)",
          "Secure Authentication",
          "Password Hashing (BCrypt, Argon2)",
          "JWT Security",
          "Token Expiry Strategies",
          "Secure API Design",
          "Secrets Management",
          "Encryption (AES, RSA)",
          "HTTPS Certificates",
          "Secure Headers",
        ],
      },
    ],
  },

  {
    phase: "Phase 17 – Frontend Awareness (Full Stack Capability)",
    topics: [
      {
        title: "Frontend Engineering",
        points: [
          "JavaScript Fundamentals",
          "Async Programming",
          "Promises",
          "Fetch API",
          "REST API Integration",
          "Component Based Architecture",
          "State Management",
          "React Fundamentals",
          "Hooks",
          "Routing",
          "Frontend Build Tools",
          "Performance Optimization",
        ],
      },
    ],
  },

  {
    phase: "Phase 18 – Production Systems & Reliability",
    topics: [
      {
        title: "Site Reliability Engineering",
        points: [
          "SLI",
          "SLO",
          "SLA",
          "Error Budgets",
          "Incident Management",
          "On-call Practices",
          "Runbooks",
          "Chaos Engineering",
          "Fault Injection",
          "High Availability Architecture",
          "Disaster Recovery",
          "Blue Green Deployment",
          "Canary Deployments",
        ],
      },
    ],
  },

  {
    phase: "Phase 19 – Advanced System Design",
    topics: [
      {
        title: "Large Scale System Design",
        points: [
          "Design URL Shortener",
          "Design Rate Limiter",
          "Design Notification System",
          "Design Chat System",
          "Design Ride Sharing System",
          "Design Payment Gateway",
          "Design Distributed Cache",
          "Design Video Streaming System",
          "Design Social Media Feed",
          "Design Search Engine",
        ],
      },
    ],
  },

  {
    phase: "Phase 20 – Career Acceleration",
    topics: [
      {
        title: "Career Growth for Product Companies",
        points: [
          "Advanced DSA Practice",
          "Low Level Design",
          "High Level Design",
          "Architecture Discussions",
          "Technical Blogging",
          "Open Source Contributions",
          "Portfolio Projects",
          "GitHub Engineering Profile",
          "Engineering Resume Optimization",
          "Mock Interviews",
          "Coding Contests",
          "Technical Presentation Skills",
        ],
      },
    ],
  },
  {
  phase: "Phase 21 – Python & Data Foundations for AI",
  topics: [
    {
      title: "Python Programming for AI",
      points: [
        "Python syntax and data types",
        "Lists, Tuples, Sets, Dictionaries",
        "Functions and Lambda Functions",
        "Object Oriented Programming in Python",
        "File Handling",
        "Virtual Environments",
        "Working with APIs",
        "JSON Processing",
        "Exception Handling",
      ],
      resources: [
        "Python for Everybody – University of Michigan (Coursera)",
        "Automate the Boring Stuff with Python",
        "Kaggle Python Micro Course",
      ],
      usage: [
        "AI microservices",
        "data preprocessing",
        "automation scripts",
        "log analysis",
      ],
    },
    {
      title: "Data Processing Libraries",
      points: [
        "NumPy arrays",
        "Vectorized operations",
        "Pandas DataFrames",
        "Data cleaning",
        "Data transformations",
        "Data visualization",
      ],
      resources: [
        "Kaggle Pandas Course",
        "Data Analysis with Python – freeCodeCamp",
      ],
      usage: [
        "data pipelines",
        "machine learning datasets",
        "analytics systems",
      ],
    },
  ],
},

{
  phase: "Phase 22 – Machine Learning Fundamentals",
  topics: [
    {
      title: "Core Machine Learning Concepts",
      points: [
        "Supervised Learning",
        "Unsupervised Learning",
        "Training vs Testing Data",
        "Overfitting vs Underfitting",
        "Bias vs Variance",
        "Model Evaluation Metrics",
      ],
      resources: [
        "Machine Learning Course – Andrew Ng (Coursera)",
        "Google Machine Learning Crash Course",
      ],
      usage: [
        "fraud detection",
        "customer churn prediction",
        "predictive analytics",
      ],
    },
    {
      title: "Machine Learning Algorithms",
      points: [
        "Linear Regression",
        "Logistic Regression",
        "Decision Trees",
        "Random Forest",
        "K-Means Clustering",
        "Model evaluation",
      ],
      resources: [
        "Hands-On Machine Learning with Scikit-Learn",
        "Kaggle ML Practice Datasets",
      ],
      usage: [
        "risk prediction",
        "recommendation systems",
        "business analytics",
      ],
    },
  ],
},

{
  phase: "Phase 23 – Deep Learning Foundations",
  topics: [
    {
      title: "Neural Networks",
      points: [
        "Neurons and layers",
        "Activation functions",
        "Forward propagation",
        "Backpropagation",
        "Loss functions",
        "Training pipelines",
      ],
      resources: [
        "Deep Learning Specialization – Andrew Ng",
        "FastAI Practical Deep Learning",
      ],
      usage: [
        "image recognition",
        "speech recognition",
        "object detection",
      ],
    },
    {
      title: "Deep Learning Frameworks",
      points: [
        "TensorFlow basics",
        "PyTorch fundamentals",
        "Model training",
        "Model evaluation",
        "Saving and loading models",
      ],
      resources: [
        "PyTorch Official Tutorials",
        "TensorFlow Developer Guide",
      ],
      usage: [
        "computer vision",
        "NLP systems",
        "AI product features",
      ],
    },
  ],
},

{
  phase: "Phase 24 – LLM Engineering (Modern AI Applications)",
  topics: [
    {
      title: "Large Language Model Applications",
      points: [
        "Prompt Engineering",
        "Tokenization",
        "Context windows",
        "Prompt templates",
        "Chain of thought prompting",
      ],
      resources: [
        "DeepLearning.AI Prompt Engineering Course",
        "OpenAI Documentation",
      ],
      usage: [
        "chatbots",
        "code assistants",
        "document analysis",
      ],
    },
    {
      title: "LLM Application Frameworks",
      points: [
        "LangChain fundamentals",
        "LlamaIndex basics",
        "Embedding models",
        "Semantic search",
        "Retrieval Augmented Generation (RAG)",
      ],
      resources: [
        "LangChain Documentation",
        "LlamaIndex Tutorials",
      ],
      usage: [
        "AI search engines",
        "enterprise document search",
        "knowledge assistants",
      ],
    },
  ],
},

{
  phase: "Phase 25 – Vector Databases & AI Search",
  topics: [
    {
      title: "Embeddings & Vector Search",
      points: [
        "Text embeddings",
        "Similarity search",
        "Semantic search",
        "Embedding pipelines",
      ],
      resources: [
        "OpenAI Embeddings Guide",
        "Pinecone Vector Search Tutorials",
      ],
      usage: [
        "AI search systems",
        "recommendation engines",
        "chatbot memory",
      ],
    },
    {
      title: "Vector Databases",
      points: [
        "Pinecone fundamentals",
        "Weaviate basics",
        "Milvus architecture",
        "Vector indexing",
        "Hybrid search",
      ],
      resources: [
        "Pinecone Docs",
        "Weaviate Tutorials",
      ],
      usage: [
        "AI assistants",
        "document retrieval systems",
        "semantic search engines",
      ],
    },
  ],
},

{
  phase: "Phase 26 – AI System Architecture",
  topics: [
    {
      title: "AI Microservices Architecture",
      points: [
        "Spring Boot AI integration",
        "Python AI services",
        "REST APIs for ML models",
        "Async AI processing",
        "Caching AI responses",
      ],
      resources: [
        "Building ML APIs with FastAPI",
        "ML System Design Interview Guide",
      ],
      usage: [
        "AI-powered APIs",
        "enterprise AI platforms",
      ],
    },
    {
      title: "AI Deployment",
      points: [
        "Docker for ML services",
        "Model containerization",
        "Kubernetes deployments",
        "Scaling AI services",
      ],
      resources: [
        "Docker ML Deployment Tutorials",
        "Kubernetes ML Deployment Guides",
      ],
      usage: [
        "production AI platforms",
        "scalable AI APIs",
      ],
    },
  ],
},

{
  phase: "Phase 27 – MLOps & Production AI",
  topics: [
    {
      title: "MLOps Fundamentals",
      points: [
        "Model versioning",
        "Experiment tracking",
        "Model monitoring",
        "Data drift detection",
        "Automated retraining",
      ],
      resources: [
        "MLOps Specialization – Coursera",
        "MLflow Documentation",
      ],
      usage: [
        "production ML systems",
        "AI reliability engineering",
      ],
    },
    {
      title: "Data Pipelines for AI",
      points: [
        "Apache Airflow workflows",
        "Apache Spark processing",
        "Kafka streaming data",
        "Batch vs stream ML pipelines",
      ],
      resources: [
        "Apache Airflow Tutorials",
        "Spark ML Guides",
      ],
      usage: [
        "real-time analytics",
        "fraud detection pipelines",
      ],
    },
  ],
},

{
  phase: "Phase 28 – AI Projects (Portfolio)",
  topics: [
    {
      title: "Real AI Projects",
      points: [
        "AI Document Chatbot (RAG)",
        "AI Code Review Tool",
        "AI Log Analyzer",
        "Recommendation System",
        "AI Knowledge Base Search Engine",
      ],
      resources: [
        "LangChain Project Tutorials",
        "Full Stack LLM Bootcamp",
      ],
      usage: [
        "portfolio projects",
        "enterprise AI applications",
        "resume projects",
      ],
    },
  ],
},

];
